import { ScreenTimeSlot } from './screen-time-slot.model';

export class ScreenStoreHour {
  day: string;
  slots: ScreenTimeSlot[];
  constructor(day: string, slots: ScreenTimeSlot[]) {
    this.day = day || null;
    this.slots = slots || [];
  }
}
